/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpSharedDealerDetailsHeader_user$ref = any;
export type PdpRespDealerDetailsStats_user$ref = any;
export type PdpRespDealerDetailsStats_user = {
    readonly " $fragmentRefs": PdpSharedDealerDetailsHeader_user$ref;
    readonly " $refType": PdpRespDealerDetailsStats_user$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespDealerDetailsStats_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDealerDetailsHeader_user",
      "args": null
    }
  ]
};
(node as any).hash = '76a3ccc76e649cf40a4e2b84d0604094';
export default node;
